import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import React, { useLayoutEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { CalendarIcon } from "Assets/index";
import { format } from "Shared/Utils/shared";
import { FORMAT_WITHOUT_TIME } from "Shared/Constants/app";

import styles from "./DateRange.module.scss";
import {
  firstDateOfCurrentMonth,
  lastDateOfCurrentMonth,
} from "Shared/Constants/dashboard";

type ValuePiece = Date | null;

export type Value = ValuePiece | [ValuePiece, ValuePiece];
type DateRangeProps = {
  onDateChange?: (searchParams: URLSearchParams) => void;
  rangeStartName?: string;
  rangeEndName?: string;
  dateRangeName?: string;
};

const DateRange: React.FC<DateRangeProps> = ({
  onDateChange,
  rangeStartName = "from",
  rangeEndName = "to",
  dateRangeName = "range_date",
}) => {
  const today = new Date();
  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(today.getDate() - 30);
  const [value, onChange] = useState<Value>();
  const [searchParams, setSearchParams] = useSearchParams();

  const changeDate = (value: Value) => {
    if (value && Array.isArray(value)) {
      if (value[0]) {
        searchParams.set(rangeStartName, format(value[0], FORMAT_WITHOUT_TIME));
      }
      if (value[1]) {
        searchParams.set(rangeEndName, format(value[1], FORMAT_WITHOUT_TIME));
      }
      searchParams.set(dateRangeName, "true");
    } else {
      searchParams.delete(rangeStartName);
      searchParams.delete(rangeEndName);
      searchParams.delete(dateRangeName);
    }
    searchParams.delete("range");
    onDateChange?.(searchParams);
    setSearchParams(searchParams);
  };

  useLayoutEffect(() => {
    const from = searchParams.get(rangeStartName) || firstDateOfCurrentMonth;
    const to = searchParams.get(rangeEndName) || lastDateOfCurrentMonth;

    if (from && to) {
      const fromDate = new Date(from);
      const toDate = new Date(to);
      if (isNaN(fromDate.getTime()) || isNaN(toDate.getTime())) return;
      onChange([new Date(from), new Date(to)]);
    }
  }, []);

  return (
    <div className={styles.date}>
      <DateRangePicker
        onChange={(value: any) => {
          changeDate?.(value);
          onChange(value);
        }}
        value={searchParams.has(rangeStartName) ? value : ""}
        calendarIcon={<CalendarIcon />}
        dayPlaceholder="dd"
        monthPlaceholder="mm"
        yearPlaceholder="yyyy"
        rangeDivider=" "
      />
    </div>
  );
};
export default DateRange;
